var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeRub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2 10.71V0H4.62C6 0 7.005 0.28 7.635 0.84C8.275 1.4 8.595 2.17 8.595 3.15C8.595 3.73 8.465 4.275 8.205 4.785C7.945 5.295 7.51 5.705 6.9 6.015C6.3 6.325 5.48 6.48 4.44 6.48H3.465V10.71H1.2ZM0 9.105V7.65H5.775V9.105H0ZM0 6.48V4.62H4.395V6.48H0ZM4.215 4.62C4.645 4.62 5.015 4.575 5.325 4.485C5.635 4.385 5.875 4.23 6.045 4.02C6.215 3.81 6.3 3.545 6.3 3.225C6.3 2.765 6.155 2.425 5.865 2.205C5.575 1.975 5.12 1.86 4.5 1.86H3.465V4.62H4.215Z",
    fill: "#FF7834"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRub);
export default __webpack_public_path__ + "static/media/orangeRub.95452b1b2a6efc9c583734bc94b96907.svg";
export { ForwardRef as ReactComponent };